import { useState } from "react";
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import { Outlet } from "react-router-dom";

const CustomerScreen = () => {
  const sidebar = useSelector(state => state.sidebar);
  const [addProductPage, setAddProductPage] = useState(false);
  return (
    <div className="dashboardOuterContainer overflow-y-scroll no-scrollbar">
      {/* <SideBar /> */}
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        }`}>
        <BreadCrumbsContainer />
        <div className="dashboardDataCardContainer ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CustomerScreen;
